import { FC } from "react";
import { useMatchDataPolling } from "../hooks/useMatchDataPolling";

export const CompanyMatchPollingManager: FC = () => {
  // Create polling hooks with the current workspace
  useMatchDataPolling({ type: "whitespace" });
  useMatchDataPolling({ type: "uploadedAccounts" });

  return null; // This component doesn't render anything
};
